const { default: CommonServices } = require("./common/common");

class TestimonialManagementService extends CommonServices {
  constructor() {
    super("/testimonials");
  }
}

const testimonialManagementService = new TestimonialManagementService();
export default testimonialManagementService;
